// extracted by mini-css-extract-plugin
export default {"emailModalDiv":"ReportActionMenu_emailModalDiv__ePlMO","buttonContainer":"ReportActionMenu_buttonContainer__jn+TX","header":"ReportActionMenu_header__tPqop"};